import { ENVIRONMENT } from "shared/lib/constants/environment";

export const LANDING_OPENINGS_URL = {
  [ENVIRONMENT.LOCAL]: "http://localhost:3004/openings/remote-sales-jobs",
  [ENVIRONMENT.STAGING]:
    "https://landing-staging.glencoco.com/openings/remote-sales-jobs",
  [ENVIRONMENT.PRODUCTION]: "https://glencoco.com/openings/remote-sales-jobs",
};

export const USER_PLATFORM_URL = {
  [ENVIRONMENT.LOCAL]: "http://localhost:3000",
  [ENVIRONMENT.STAGING]: "https://user-staging.glencoco.com",
  [ENVIRONMENT.PRODUCTION]: "https://user.glencoco.com",
};

export const CUSTOMER_AND_GLENX_LOCAL_URL = "http://localhost:3001";

export const CUSTOMER_PLATFORM_URL = {
  [ENVIRONMENT.LOCAL]: CUSTOMER_AND_GLENX_LOCAL_URL,
  [ENVIRONMENT.STAGING]: "https://customer-staging.glencoco.com",
  [ENVIRONMENT.PRODUCTION]: "https://customer.glencoco.com",
};

export const GLENX_ADMIN_URL = {
  [ENVIRONMENT.LOCAL]: CUSTOMER_AND_GLENX_LOCAL_URL,
  [ENVIRONMENT.STAGING]: "https://admin-staging.glenx.ai",
  [ENVIRONMENT.PRODUCTION]: "https://admin.glenx.ai",
};

export const GLENX_LANDING_URL = {
  [ENVIRONMENT.LOCAL]: "http://localhost:3005",
  [ENVIRONMENT.STAGING]: "https://landing-staging.glenx.ai",
  [ENVIRONMENT.PRODUCTION]: "https://glenx.ai",
};

export const URL_WITHOUT_PROTOCOL_REGEX =
  /^(?:https?:\/\/)?(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?::\d{2,5})?(?:[/?#][^\s]*)?$/;

// LinkedIn vanity URLs come in many shapes by region:
//
//   https://www.linkedin.com/in/jane-doe          (US default)
//   https://uk.linkedin.com/in/jane-doe           (country subdomain — UK/CA/DE/IN/AU/...)
//   https://www.linkedin.com/in/jane.doe-123      (dot in slug)
//   https://www.linkedin.com/in/%E5%B1%B1%E7%94%B0 (percent-encoded Unicode)
//
// Previous regex required the subdomain to be exactly `www.` or absent,
// and the slug to be `[\w-]+`. That rejected every UK / CA / DE / IN
// applicant whose LinkedIn profile lives at a country subdomain, plus
// any slug containing a dot or percent encoding. Widened to:
//   * Optional 2–3 char country subdomain or `www.`
//   * Slug allows letters, digits, hyphens, underscores, dots, and
//     percent-encoded chars. Trailing slash optional.
//
// SECURITY NOTE: the slug class accepts percent-encoded bytes (e.g.
// `%E5%B1%B1` for CJK profile names). That same encoding can also
// represent `/` (`%2F`) and `..` (`%2E%2E`). The regex does not decode,
// so a matched URL passes through verbatim — safe as a typed input.
// Callers that interpolate the matched value into a server-side path
// MUST first round-trip it through `new URL(...)` (which decodes and
// canonicalises) to prevent path-traversal sequences from leaking
// downstream. Treat the matched string as untrusted user input, not as
// a sanitized path component.
export const LINKEDIN_REGEX =
  /^(https?:\/\/)?([a-z]{2,3}\.)?linkedin\.com\/(in|pub|public-profile\/in|public-profile\/pub)\/[\w.\-%]+\/?$/i;
